
import { ComparisonResponseDTO, filtersDTO, saveStatusParticelleStruttureDTO } from "./dto";
import { NotComparisonImpl } from "./serviceImpl";

export interface NotComparisonService {
    GetNotComparison(filters: filtersDTO): Promise<ComparisonResponseDTO>
    UpdateStatusParticelle(data: saveStatusParticelleStruttureDTO, id: string): Promise<void>
    UpdateStatusStrutture(data: saveStatusParticelleStruttureDTO, id: string): Promise<void>
}

export function NewNotComparisonService(): NotComparisonService {
    return new NotComparisonImpl()
}